export default __webpack_public_path__ + "static/media/2.23007cf5.png";